export default __webpack_public_path__ + "static/media/construction.cb3a9210.jpg";